import React from 'react';
import classNames from 'classnames';
import { Show } from '../../components/shared/Show';
import { ErrorTextTW } from './ErrorTextTW';
import { IHasTestData } from '../../ui-toolkit/test-utilities/IHasTestData';
import { HintTextTW } from './HintTextTW';
import { MobilityHeaderLabelText } from './MobilityHeaderLabelText';

export interface MobilityHeaderFormCellProps extends IHasTestData {
  /** Additional CSS class. */
  className?: string;
  /** Message to display when the input is in an error state. When this is present, also visually highlights the component as in error. */
  errorText?: string;
  /** Hint text content. */
  hintText?: string;
  /** Highlights the input as a required field (does also perform additional validation). */
  isRequired?: boolean;
  /** This label appears above the input. */
  labelText?: string;

  labelClassName?: string;

  /** all elements are disabled*/
  disabled?: boolean;
  name?: string;
  isInlineLabel?: boolean;
  showErrorText?: boolean;
  children?: React.ReactNode;
}

export const MobilityHeaderFormCell: React.FC<MobilityHeaderFormCellProps> = ({
  labelText,
  errorText,
  hintText,
  isRequired,
  disabled,
  name,
  className,
  children,
  isInlineLabel,
  labelClassName,
  showErrorText,
}) => {
  if (isInlineLabel && !!labelText) {
    return (
      <div className={classNames(className)}>
        <div className={'flex gap-1'}>
          <MobilityHeaderLabelText
            labelText={labelText}
            isError={!!errorText}
            isRequired={isRequired}
            name={name}
            className={labelClassName}
          />
          {children}
        </div>
        <Show when={!!errorText && !!showErrorText} fallback={<HintTextTW hintText={hintText} disabled={disabled} />}>
          <ErrorTextTW errorText={errorText} />
        </Show>
      </div>
    );
  }

  return (
    <div className={classNames(className)}>
      <Show when={!!labelText}>
        <MobilityHeaderLabelText labelText={labelText} isError={!!errorText} isRequired={isRequired} name={name} />
      </Show>
      {children}
      <Show when={!!errorText} fallback={<HintTextTW hintText={hintText} disabled={disabled} />}>
        <ErrorTextTW errorText={errorText} />
      </Show>
    </div>
  );
};
